import { render, staticRenderFns } from "./PersonOverviewResults.vue?vue&type=template&id=3cc3de2b&scoped=true&"
import script from "./PersonOverviewResults.vue?vue&type=script&lang=js&"
export * from "./PersonOverviewResults.vue?vue&type=script&lang=js&"
import style0 from "./PersonOverviewResults.vue?vue&type=style&index=0&id=3cc3de2b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc3de2b",
  null
  
)

export default component.exports